import React from 'react';
import Layout from '../Layout/Layout';

export const withLayout = Component => props => (
    <Layout {...props}>
        <Component {...props} />
    </Layout>
);